class Orders {
  constructor(api_key, base_url, token, uid) {
    this.api_key = api_key;
    this.base_url = base_url;
    this.token = token;
    this.uid = uid;
  }
  async createOrder(orderInfo) {
    const requestUri = `${this.base_url}/user-orders/${this.uid}?key=${this.api_key}`;
    const response = await fetch(requestUri, {
      method: 'POST',
      body: JSON.stringify(orderInfo),
      headers: new Headers({
        'Authorization': `Bearer ${this.token}`,
        'content-type': 'application/json',
      }),
    });
    return response;
  }
  async getOrders() {
    const requestUri = `${this.base_url}/user-orders/${this.uid}?key=${this.api_key}`;
    const response = await fetch(requestUri, {
      method: 'get',
      headers: new Headers({
        'Authorization': `Bearer ${this.token}`,
        'content-type': 'aplication/json',
      }),
    });
    return response.json();
  }
  async getOrderById(orderId) {
    const requestUri = `${this.base_url}/user-orders/${this.uid}/${orderId}?key=${this.api_key}`;
    const response = await fetch(requestUri, {
      method: 'get',
      headers: new Headers({
        'Authorization': `Bearer ${this.token}`,
        'content-type': 'aplication/json',
      }),
    });
    return response.json();
  }
  postOrder(uid, productInfo) {
    console.log(uid, productInfo);
  }
  async Query(param) {
    const final_uri = `${this.base_url}/${param}?key=${this.api_key}`;
    const response = await fetch(final_uri, {
      method: 'get',
      headers: new Headers({
        'Authorization': `Bearer ${this.token}`,
        'content-type': 'aplication/json',
      }),
    });
    return response.json();
  }
}

export { Orders as O };
